<template>
  <div class="text-left" >
    
    <div v-for="section in data.layout.layoutSections" :key="section.sectionId" role="tablist">
      
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button id="sectionbutton" block variant="light" size="sm"  class="text-left" v-b-toggle="section.sectionId"><b>{{ section.label }}</b></b-button>
        </b-card-header>

        <b-collapse :id="section.sectionId">
          
          <div v-for="item in section.layoutSectionItems" :key="item.itemId">
         
            <label for="item.itemId" class="control-label pl-2 mb-0"> <small><b>{{item.label}}</b></small></label>
              
              <div v-for="(entry) in journalEntry(item.itemId)" :key="entry.id">   

                <div class="pr-3 text-right"> <b-form-checkbox  v-model="entry.noReport" v-on:change="update(entry)" > <small>{{item.noReportLabel}}</small>  </b-form-checkbox>  </div>

                <div class="pl-2 pr-2 pb-2">
                      <b-form-textarea
                        id="item.itemId"
                        v-model="entry.remarks"
                        v-on:change="update(entry)"
                        size="sm"
                        rows="3"
                        max-rows="6"
                        maxlength="2000"
                        style="color:darkblue;"
                        >
                      </b-form-textarea> 
                  </div>
             
              </div>

          </div>
 
        </b-collapse>

      </b-card>

    </div>
  
    <hr>
  
  </div>
</template>

<script>
export default {
  name: "JournalEntries",
  props: {
    data: Object
  },

  data: function() {
    return {
      isBusy: true,
      loading: true,
      loaded: false,
      errored: false,
      error: ""
    };
  },

  methods: {
    journalEntry(itemId) {
      var result = new Array();
      var entry = this.data.journalEntries.find(e => e.itemId == itemId);

      if (entry){
        result.push(entry);
      }
      else{
        result.push( {id: 0, itemId: itemId, journalPageId: this.data.id, noReport: null, remarks: '' } );
      };

      return result;

    },

    update(entry){
        this.$auth.acquireToken().then(token => {
        this.$http
          .put("api/JournalEntry/" + entry.id, entry, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.errored = false;
            this.error = "";
            //if new entry add to data model 
            if (entry.id == 0){
              this.data.journalEntries.push(response.data);
            };
          })
          .catch(error => {
            console.log(error);
            this.errored = true;
            this.error = error.response.statusText;
          })
          .finally(() => (this.isBusy = false));
      });

  }

  }

};

</script>

<style>

#sectionbutton{
   color:darkred;
}

</style>